import { Action } from '@ngrx/store';

export const CLEAR_TRANSACCIONES_DATA = '[Transacciones] Clear Transacciones Data';

export class clearTransaccionesData implements Action {
    readonly type = CLEAR_TRANSACCIONES_DATA;
}

export type transaccionesActions = clearTransaccionesData;
